import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { callGPTAPI } from '../utils/api';
export function GptApiTest() {
  const [instructions, setInstructions] = useState('');
  const [prompt, setPrompt] = useState('');
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const handleRun = async () => {
    if (!instructions.trim() || !prompt.trim()) {
      setError('Both Instructions and Prompt are required');
      return;
    }
    setLoading(true);
    setError(null);
    setResponse(null);
    try {
      const result = await callGPTAPI(instructions, prompt);
      setResponse(result);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Unknown error occurred';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  return <div className="space-y-6" data-id="element-4560">
      {/* Header */}
      <div className="flex items-center gap-4" data-id="element-4561">
        <Link to="/api-test" className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-md transition-colors" data-id="element-4562">
          <ArrowLeft className="h-5 w-5" data-id="element-4563" />
        </Link>
        <div data-id="element-4564">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-4565">GPT API Test</h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-4566">
            Test GPT API integration with custom instructions and prompts.
          </p>
        </div>
      </div>

      {/* Info Banner */}
      <div className="bg-gradient-to-br from-purple-50 to-blue-50 border border-purple-200 rounded-lg p-4" data-id="element-4567">
        <p className="text-sm text-purple-800" data-id="element-4568">
          <strong data-id="element-4569">GPT API Test</strong> — Provide system instructions and a
          prompt to test the GPT API integration. The response will be displayed
          below.
        </p>
      </div>

      {/* Form */}
      <div className="bg-white border border-gray-200 rounded-lg p-6 space-y-6" data-id="element-4570">
        <div data-id="element-4571">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-4572">
            Instructions
          </label>
          <textarea value={instructions} onChange={e => setInstructions(e.target.value)} rows={6} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500 text-sm font-mono" placeholder="Enter system instructions for the GPT model..." data-id="element-4573" />
          <p className="mt-1 text-xs text-gray-500" data-id="element-4574">
            System-level instructions that guide the model's behavior
          </p>
        </div>

        <div data-id="element-4575">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-4576">
            Prompt
          </label>
          <textarea value={prompt} onChange={e => setPrompt(e.target.value)} rows={8} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500 text-sm font-mono" placeholder="Enter your prompt..." data-id="element-4577" />
          <p className="mt-1 text-xs text-gray-500" data-id="element-4578">
            The user message or query to send to the model
          </p>
        </div>

        <div data-id="element-4579">
          <button onClick={handleRun} disabled={loading || !instructions.trim() || !prompt.trim()} className="inline-flex items-center gap-2 px-5 py-2.5 bg-purple-600 text-white text-sm font-medium rounded-md hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-4580">
            {loading ? <>
                <Loader2 className="h-4 w-4 animate-spin" data-id="element-4581" />
                Running...
              </> : 'Run'}
          </button>
        </div>
      </div>

      {/* Error Display */}
      {error && <div className="bg-red-50 border border-red-200 rounded-lg p-4" data-id="element-4582">
          <p className="text-sm font-medium text-red-800" data-id="element-4583">Error</p>
          <p className="text-sm text-red-700 mt-1 font-mono whitespace-pre-wrap" data-id="element-4584">
            {error}
          </p>
        </div>}

      {/* Response Display */}
      {response && <div data-id="element-4585">
          <div className="flex items-center justify-between mb-2" data-id="element-4586">
            <p className="text-sm font-medium text-gray-700" data-id="element-4587">Response</p>
            <button onClick={() => {
          setResponse(null);
          setError(null);
        }} className="px-3 py-1.5 text-xs font-medium text-gray-600 bg-white border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-4588">
              Clear
            </button>
          </div>
          <div className="bg-white border border-gray-200 rounded-lg p-5 max-h-[60vh] overflow-auto" data-id="element-4589">
            <pre className="text-sm text-gray-900 whitespace-pre-wrap break-words" data-id="element-4590">
              {response}
            </pre>
          </div>
        </div>}
    </div>;
}